"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var useStyle = (0, _makeStyle.default)('ComponentTokenEditorDemoWrapper', function (token) {
  return (0, _defineProperty2.default)({}, "".concat(token.componentCls), (0, _defineProperty2.default)({
    height: 0,
    overflow: 'auto',
    flex: 1,
    background: token.colorBgLayout
  }, "& > ".concat(token.rootCls, "-card"), {
    margin: 24,
    width: 'calc(100% - 48px)'
  }));
});
var DemoWrapper = function DemoWrapper(_ref2) {
  var children = _ref2.children;
  var prefixCls = "antd-component-token-editor-demo-wrapper";
  var _useStyle = useStyle(prefixCls),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(prefixCls, hashId)
  }, children);
};
var _default = exports.default = DemoWrapper;